import React from 'react';
import { FormattedNumber, FormattedDate } from 'react-intl';

interface Props {
  PageData?: any;
  Model?: any;
}

const RepaymentPlanDetails = ({ PageData, Model }: Props) => {
  return (
    <div className="Grid-cell u-lg-size1of1 u-paddingHz">
      <dl className="Grid Repaymentlist">
        <div className="Grid-cell u-size1of1 u-md-size1of3">
          <dt>{PageData.PlanDetailsCurrentBalanceLabel}</dt>
          <dd>
            {typeof Model.PlanDetails.PlanDetailsCurrentBalance === 'string' ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: Model.PlanDetails.PlanDetailsCurrentBalance,
                }}
              />
            ) : (
              <FormattedNumber
                value={Model.PlanDetails.PlanDetailsCurrentBalance}
                style="currency"
                currency={Model?.currency}
              />
            )}
          </dd>
        </div>
        <div className="Grid-cell u-size1of1 u-md-size1of3">
          <dt>{PageData.PlanDetailsNumberofInstallmentsLabel}</dt>
          <dd>
            {typeof Model.PlanDetails.PlanDetailsNumberofInstallments ===
            'string' ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: Model.PlanDetails.PlanDetailsNumberofInstallments,
                }}
              />
            ) : (
              <FormattedNumber
                value={Model.PlanDetails.PlanDetailsNumberofInstallments}
                style="currency"
                currency={Model?.currency}
              />
            )}
          </dd>
        </div>
        {Model.PlanDetails.PlanDetailsFinalPaymentAmount != null && (
          <div className="Grid-cell u-size1of1 u-md-size1of3">
            <dt>{PageData.PlanDetailsFinalPaymentAmountLabel}</dt>
            <dd>
              {typeof Model.PlanDetails.PlanDetailsFinalPaymentAmount ===
              'string' ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: Model.PlanDetails.PlanDetailsFinalPaymentAmount,
                  }}
                />
              ) : (
                <FormattedNumber
                  value={Model.PlanDetails.PlanDetailsFinalPaymentAmount}
                  style="currency"
                  currency={Model?.currency}
                />
              )}
            </dd>
          </div>
        )}
        <div className="Grid-cell u-size1of1 u-md-size1of3">
          {PageData.PlanDetailsFirstPaymentDueDateLabel != null && (
            <dt>{PageData.PlanDetailsFirstPaymentDueDateLabel}</dt>
          )}
          {PageData.PlanDetailsPaymentDueDateLabel != null && (
            <dt>{PageData.PlanDetailsPaymentDueDateLabel}</dt>
          )}

          <dd>{Model.PlanDetails.PlanDetailsFirstPaymentDueDate}</dd>
        </div>
        <div className="Grid-cell u-size1of1 u-md-size1of3">
          <dt>{PageData.PlanDetailsPaymentMethodLabel}</dt>
          <dd>{Model.PlanDetails.PlanDetailsPaymentMethod}</dd>
        </div>
        <div className="Grid-cell u-size1of1 u-md-size1of3">
          <dt>{PageData.PlanDetailsCustomerNumberLabel}</dt>
          <dd>{Model.PlanDetails.PlanDetailsCustomerNumber}</dd>
        </div>
        {Model.PlanDetails.ExternalReference != null && (
          <div className="Grid-cell u-size1of1 u-md-size1of3">
            <dt>{PageData.ExternalPaymentReferenceNumber}</dt>
            <dd>{Model.PlanDetails.ExternalReference}</dd>
          </div>
        )}
      </dl>
    </div>
  );
};

export default RepaymentPlanDetails;
